import styled from 'styled-components';
import { Form as FinalForm } from 'react-final-form';

import DrawerForm from 'forms/DrawerForm';

export const FinalFormWrapper = styled(FinalForm)``;

export const FormWrapper = styled(DrawerForm)``;
